const previews = {};

export const addUploadingFilePreview = (uploadId, rawFile) => {
    if (!window.FileReader) {
        return;
    }
    if (!rawFile) {
        return;
    }
    if (/^image/.test(rawFile.type)) { // only image file
        const reader = new FileReader(); // instance of the FileReader
        reader.readAsDataURL(rawFile); // read the local file

        reader.onloadend = function() { // set image data as background of div
            previews[uploadId] = this.result;
        }
    }
};

export const removeUploadingFilePreview = (uploadId) => {
    const rawFile = previews[uploadId];
    delete previews[uploadId];
    return rawFile;
};

export const getUploadingFilePreview = (uploadId) => {
    return previews[uploadId];
};



// WEBPACK FOOTER //
// ./src/reducers/uploadingFilePreviews.js